import { Col, Row, theme, Typography } from "antd";
import { useEffect, useState } from "react";
import { getRoadmaps } from "../../repository/data.repository";
import { Roadmap } from "../../repository/data.default";
import RichText from "../ui/RichText";

// Data-driven from the active roadmap's authored Overview — renders the admin's short description
// (as-is, no casing transform) + the rich description/steps, so what an admin types is what shows.
function Introduction() {
  const { token } = theme.useToken();
  const [roadmap, setRoadmap] = useState<Roadmap | null>(null);

  useEffect(() => {
    getRoadmaps({
      searchQuery: { conditions: [] },
      pageNumber: 0,
      pageSize: 1,
      sortBy: "createdOn",
      sortDescending: false,
    })
      .then((d) => setRoadmap(d.data[0] ?? null))
      .catch(() => setRoadmap(null));
  }, []);

  if (!roadmap) return null;

  const textStyle = { color: "white", fontFamily: token.fontFamily };

  return (
    <Col className="mb-8">
      <Row className="bg-[#067CA0] p-8 shadow-sm">
        <Col span={24}>
          <Typography.Title level={3} style={textStyle}>
            {roadmap.shortDescription || "Introduction"}
          </Typography.Title>
          <RichText
            html={roadmap.description}
            className="text-justify text-base leading-relaxed tracking-wide"
            style={textStyle}
          />
          <RichText
            html={roadmap.stepsDescription}
            className="mt-2 text-base leading-relaxed tracking-wide"
            style={textStyle}
          />
        </Col>
      </Row>
    </Col>
  );
}

export default Introduction;
